import React from "react";
import ObservedSection from "../../components/ObservedSection";
import CTAButton from "../../components/CTAButton";
import styles from "./MainMobile.module.css";

const Pricing = ({ onEnter, onLeave }) => {
    return (
        <div className={styles.product_details}>
            <div className={styles.product_title}>
                OTUS- Thiết bị luyện tập mắt
                số 1 Hàn Quốc
                được các mẹ tin chọn
            </div>
            <ul className={styles.product_benefits}>
                <li>Luyện cơ mắt với 8 thấu kính quang học đặc biệt</li>
                <li>Dễ dàng sử dụng mọi lúc – khi xem TV hay lướt điện thoại.</li>
                <li>Đồng hành cùng thói quen chăm sóc mắt khỏe mạnh mỗi ngày</li>
            </ul>

            {/* Pricing */}
            <div>

            </div>
            <div className={styles.pricing}>
                <div>
                    <p className={styles.pricing_label}>Giá bán lẻ:</p>
                    <p className={styles.original_price}>
                        7,000,000 VND
                    </p>
                </div>
                <div>
                    <p className={styles.pricing_label}>Giá ưu đãi ra mắt:</p>
                    <p className={styles.special_price}>
                        6,000,000 VND <span style={{ color: '#ff0000' }}>(Giảm 14%)</span>
                    </p>
                </div>
                <div>
                    <p className={styles.pricing_label}>Bảo hành:</p>
                    <p className={styles.warranty}>miễn phí 12 tháng</p>
                </div>

                <div>
                    <p className={styles.pricing_label}>Trả góp 0%:</p>
                    <p className={styles.special_price}>1,000,000 VND <span style={{ fontWeight: 400 }}>x</span> 6 tháng</p>
                    <span className={styles.special_price_detail}>(Thanh toán bằng Shopee Spay Later)</span>
                </div>

            </div>

            {/* CTA Button */}
            <ObservedSection
                onEnter={onEnter}
                onLeave={onLeave}
            >
                <CTAButton
                    className={styles.cta}
                    titleClass={styles.cta_title}
                    subtitleClass={styles.cta_sub}
                    iconClass={styles.cta_icon}
                />
            </ObservedSection>
        </div>
    )
}

export default Pricing